export const PLAIN_LANGUAGE_EXAMPLES = [
  {
    key: '1',
    value: 'Synthesis of 4-methyldiphenylamine with a yield higher than 70% using Buchwald-Hartwig reaction',
  },
  { key: '2', value: 'How can I convert nitrobenzene to aniline?' },
  { key: '3', value: 'Convert 91-01-0 to RWCCWEUUXYIKHB-UHFFFAOYSA-N' },
];

export const QUERY_TYPE_COLUMNS = [
  { value: 'queryType', label: 'Query type' },
  { value: 'example', label: 'Example (plain language)' },
];

export const QUERY_TYPE_EXAMPLES = [
  {
    id: 'single-reaction-detail',
    queryType: 'Single reaction detail',
    value: 'Show me reactions with supercritical conditions',
  },
  {
    id: 'named-compound',
    queryType: 'Named compound (name / CAS / InChIKey / SMILES / abbreviation)',
    value: 'How to make 162011-90-7?',
  },
  {
    id: 'two-reaction-details',
    queryType: 'Two reaction details combined',
    value: 'Diels-Alder using C2H4 as starting material',
  },
  {
    id: 'three-reaction-details',
    queryType: 'Three reaction details combined',
    value: 'Xanthine to caffeine, yield above 80%',
  },
];

export const ADDITIONAL_EXAMPLES = [
  { key: '1', value: 'What is a Stille coupling?' },
  { key: '2', value: 'What is an Appel reaction?' },
  { key: '3', value: 'Tell me what you know about the Wittig reaction at room temperature' },
  { key: '4', value: 'How to prepare astaxanthin from beta-carotene' },
  { key: '5', value: 'Large-scale synthesis of imatinib with >70% yield at room temperature' },
  { key: '6', value: 'How is celecoxib synthesised, and which routes give yields above 80%?' },
  { key: '7', value: 'Green chemistry and furfural synthesis' },
  { key: '8', value: 'Huisgen cycloaddition synthesis using flow' },
];

export const KEYWORD_EXAMPLES = [
  { key: '1', label: 'substance names', value: 'atenolol' },
  { key: '2', label: 'CAS Registry Numbers', value: '102625-70-7' },
  { key: '3', label: 'molecular formulas', value: 'Pt(PPh3)3' },
  { key: '4', label: 'named reactions', value: 'Suzuki coupling' },
  { key: '5', label: 'substance effects', value: 'anticoagulant' },
];
